(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-productos-por-coleccion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('random-collection-carousel')) {
    class RandomCollectionCarousel extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      initialize() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        const slides = Array.from(this.querySelectorAll('[data-random-slide]')).map((slide) => {
          const candidates = Array.from(slide.querySelectorAll('template[data-product-candidate]'));
          for (let index = candidates.length - 1; index > 0; index--) {
            const randomIndex = Math.floor(Math.random() * (index + 1));
            [candidates[index], candidates[randomIndex]] = [candidates[randomIndex], candidates[index]];
          }
          return { slide, candidates };
        });

        const assignedProducts = new Map();
        const assignSlide = (slideIndex, checkedProducts) => {
          for (const candidate of slides[slideIndex].candidates) {
            const productId = candidate.dataset.productId;
            if (checkedProducts.has(productId)) continue;
            checkedProducts.add(productId);

            const previousSlide = assignedProducts.get(productId);
            if (previousSlide === undefined || assignSlide(previousSlide, checkedProducts)) {
              assignedProducts.set(productId, slideIndex);
              return true;
            }
          }
          return false;
        };

        const slideOrder = slides.map((_, index) => index);
        for (let index = slideOrder.length - 1; index > 0; index--) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [slideOrder[index], slideOrder[randomIndex]] = [slideOrder[randomIndex], slideOrder[index]];
        }
        slideOrder.sort((first, second) => slides[first].candidates.length - slides[second].candidates.length);
        slideOrder.forEach((index) => assignSlide(index, new Set()));

        const selectedBySlide = new Map();
        assignedProducts.forEach((slideIndex, productId) => {
          const selected = slides[slideIndex].candidates.find((candidate) => candidate.dataset.productId === productId);
          selectedBySlide.set(slideIndex, selected);
        });

        slides.forEach(({ slide, candidates }, index) => {
          const selected = selectedBySlide.get(index);
          if (!selected) {
            slide.remove();
            return;
          }
          slide.appendChild(selected.content.cloneNode(true));
          candidates.forEach((candidate) => candidate.remove());
        });

        const section = this.closest('.rc-carousel');
        this.previousButton = section?.querySelector('[data-carousel-previous]');
        this.nextButton = section?.querySelector('[data-carousel-next]');
        this.progressIndicator = section?.querySelector('[data-carousel-progress]');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.requestControlUpdate(), { passive: true });
        this.track.addEventListener('pointerdown', (event) => this.startMouseDrag(event));
        this.track.addEventListener('pointermove', (event) => this.continueMouseDrag(event));
        this.track.addEventListener('pointerup', (event) => this.finishMouseDrag(event));
        this.track.addEventListener('pointercancel', (event) => this.finishMouseDrag(event));
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        this.track.addEventListener('click', (event) => this.handleTrackClick(event), true);
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
        this.startAutoplay();
      }

      startMouseDrag(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (this.track.scrollWidth <= this.track.clientWidth) return;

        this.dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScrollLeft: this.track.scrollLeft,
          moved: false
        };
      }

      continueMouseDrag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        const distance = event.clientX - this.dragState.startX;
        if (Math.abs(distance) > 10 && !this.dragState.moved) {
          this.dragState.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.add('is-dragging');
          this.stopAutoplay();
        }
        if (!this.dragState.moved) return;

        event.preventDefault();
        this.track.scrollLeft = this.dragState.startScrollLeft - distance;
      }

      finishMouseDrag(event) {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;
        const didMove = this.dragState.moved;

        if (this.track.hasPointerCapture(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }

        this.dragState = null;
        this.track.classList.remove('is-dragging');

        if (!didMove) return;
        this.suppressClick = true;
        window.setTimeout(() => {
          this.suppressClick = false;
        }, 0);
        this.snapToClosestSlide();
      }

      handleTrackClick(event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }

      snapToClosestSlide() {
        const slide = this.track.querySelector('[data-random-slide]');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = slide.getBoundingClientRect().width + gap;
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const destination = Math.min(maximum, Math.max(0, Math.round(this.track.scrollLeft / distance) * distance));
        this.track.scrollTo({ left: destination, behavior: this.prefersReducedMotion ? 'auto' : 'smooth' });
      }

      move(direction) {
        const slide = this.track.querySelector('[data-random-slide]');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = slide.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: distance * direction, behavior: this.prefersReducedMotion ? 'auto' : 'smooth' });
      }

      requestControlUpdate() {
        if (this.controlFrame) return;
        this.controlFrame = requestAnimationFrame(() => {
          this.updateControls();
          this.controlFrame = null;
        });
      }

      updateControls() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const isAtStart = this.track.scrollLeft <= 2;
        if (this.previousButton) this.previousButton.disabled = isAtStart;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;

        if (this.progressIndicator) {
          const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
          const indicatorWidth = Math.max(0.1, visibleRatio);
          const scrollProgress = maximum > 0 ? this.track.scrollLeft / maximum : 0;
          const travel = (1 - indicatorWidth) * scrollProgress;
          this.progressIndicator.style.width = `${indicatorWidth * 100}%`;
          this.progressIndicator.style.left = `${travel * 100}%`;
        }
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.prefersReducedMotion || this.autoplayTimer) return;
        const seconds = Number(this.dataset.autoplaySeconds) || 5;
        this.autoplayTimer = window.setInterval(() => {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          if (this.track.scrollLeft >= maximum - 2) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.move(1);
          }
        }, seconds * 1000);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) return;
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('random-collection-carousel', RandomCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards-loop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elite-image-cards-loop')) {
  customElements.define('elite-image-cards-loop', class extends HTMLElement {
    connectedCallback() {
      this.bootFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      if (!this.isConnected || this.controller) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.viewport || !this.track) return;
      this.slides = Array.from(this.track.children);
      this.controls = this.querySelector('[data-controls]');
      this.progress = this.querySelector('[data-progress]');
      this.index = 0;
      this.busy = false;
      this.blockedUntil = 0;
      this.signature = '';
      this.controller = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.controller.signal };

      this.querySelector('[data-previous]')?.addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('pointerdown', (event) => this.pointerDown(event), options);
      this.viewport.addEventListener('pointermove', (event) => this.pointerMove(event), options);
      this.viewport.addEventListener('pointerup', (event) => this.pointerEnd(event), options);
      this.viewport.addEventListener('pointercancel', (event) => this.pointerEnd(event, true), options);
      this.viewport.addEventListener('lostpointercapture', (event) => {
        if (event.target === this.viewport) this.pointerEnd(event, true);
      }, options);
      this.viewport.addEventListener('pointerleave', () => {
        if (this.pointer && !this.pointer.moving) this.releasePointer();
      }, options);
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.viewport.addEventListener('click', (event) => {
        if (Date.now() < this.blockedUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.target !== this.viewport || !this.enabled) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.jump(0);
        else if (event.key === 'End') this.jump(this.slides.length - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this.jump(index);
      }, options);
      const scheduleMeasure = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.measure());
      };
      window.addEventListener('resize', scheduleMeasure, options);
      this.resizeObserver = new ResizeObserver(scheduleMeasure);
      this.resizeObserver.observe(this.viewport);
      this.measure();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.bootFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.cancelAnimation();
      this.releasePointer();
      if (this.slides && this.track) {
        this.track.replaceChildren(...this.slides);
        this.slides.forEach((slide) => {
          slide.inert = false;
          slide.removeAttribute('aria-hidden');
        });
        this.track.style.transform = '';
      }
      this.classList.remove('is-ready', 'is-looping', 'is-dragging');
    }

    cancelAnimation() {
      clearTimeout(this.animationTimer);
      if (this.track) {
        if (this.finishHandler) this.track.removeEventListener('transitionend', this.finishHandler);
        this.track.style.transition = 'none';
      }
      this.finishHandler = null;
      this.busy = false;
    }

    releasePointer() {
      const pointer = this.pointer;
      this.pointer = null;
      if (pointer && this.viewport?.hasPointerCapture(pointer.id)) {
        this.viewport.releasePointerCapture(pointer.id);
      }
      this.classList.remove('is-dragging');
    }

    measure() {
      const width = this.viewport.clientWidth;
      if (!width) return;
      const columns = Math.max(1, parseFloat(getComputedStyle(this).getPropertyValue('--el-cols')) || 1);
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const signature = `${width}:${columns}:${gap}`;
      if (signature === this.signature) return;
      this.signature = signature;
      this.columns = columns;
      this.enabled = this.slides.length > columns;
      const slideWidth = Math.max(1, (width - gap * (columns - 1)) / columns);
      this.step = slideWidth + gap;
      this.style.setProperty('--el-slide-width', `${slideWidth}px`);
      this.classList.add('is-ready');
      this.classList.toggle('is-looping', this.enabled);
      if (this.controls) this.controls.hidden = !this.enabled;
      this.viewport.tabIndex = this.enabled ? 0 : -1;
      this.jump(this.enabled ? this.index : 0);
    }

    paint(offset) {
      this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    rotate(direction) {
      const node = direction > 0 ? this.track.firstElementChild : this.track.lastElementChild;
      if (!node) return;
      const focused = node.contains(document.activeElement) ? document.activeElement : null;
      if (direction > 0) this.track.append(node);
      else this.track.prepend(node);
      if (focused && document.activeElement !== focused) focused.focus({ preventScroll: true });
    }

    jump(index) {
      this.cancelAnimation();
      this.releasePointer();
      const count = this.slides.length;
      this.index = this.enabled && count ? ((index % count) + count) % count : 0;
      const focused = this.track.contains(document.activeElement) ? document.activeElement : null;
      this.track.replaceChildren(...this.slides.slice(this.index), ...this.slides.slice(0, this.index));
      this.viewport.scrollLeft = 0;
      this.paint(0);
      this.syncAccessibility();
      if (focused && !focused.closest('[inert]')) focused.focus({ preventScroll: true });
    }

    syncAccessibility() {
      Array.from(this.track.children).forEach((slide, index) => {
        const hidden = this.enabled && index >= Math.ceil(this.columns);
        if (hidden && slide.contains(document.activeElement)) this.viewport.focus({ preventScroll: true });
        slide.inert = hidden;
        if (hidden) slide.setAttribute('aria-hidden', 'true');
        else slide.removeAttribute('aria-hidden');
      });
      if (this.progress) {
        this.progress.style.setProperty('--el-progress', (this.index + 1) / Math.max(1, this.slides.length));
      }
    }

    animate(target, complete) {
      this.busy = true;
      const duration = this.motion.matches ? 0 : 400;
      this.track.getBoundingClientRect();
      this.track.style.transition = duration ? `transform ${duration}ms ease` : 'none';
      const finish = (event) => {
        if (event && (event.target !== this.track || event.propertyName !== 'transform')) return;
        this.cancelAnimation();
        complete();
        this.paint(0);
        this.syncAccessibility();
      };
      this.finishHandler = finish;
      this.track.addEventListener('transitionend', finish);
      this.paint(target);
      if (duration) this.animationTimer = setTimeout(() => finish(), duration + 100);
      else finish();
    }

    move(direction) {
      if (!this.enabled || this.busy || this.pointer) return;
      this.track.style.transition = 'none';
      if (direction < 0) {
        this.rotate(-1);
        this.paint(-this.step);
        this.syncAccessibility();
      }
      this.animate(direction > 0 ? -this.step : 0, () => {
        if (direction > 0) this.rotate(1);
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
      });
    }

    pointerDown(event) {
      if (!this.enabled || this.busy || !event.isPrimary || event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;
      this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, delta: 0, moving: false, prepared: false };
    }

    pointerMove(event) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      const deltaX = event.clientX - pointer.x;
      const deltaY = event.clientY - pointer.y;
      if (!pointer.moving) {
        if (Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)) {
          this.releasePointer();
          return;
        }
        if (Math.abs(deltaX) < 8) return;
        pointer.moving = true;
        this.viewport.setPointerCapture(pointer.id);
        this.classList.add('is-dragging');
        this.track.style.transition = 'none';
      }
      if (event.cancelable) event.preventDefault();
      pointer.delta = Math.max(-this.step, Math.min(this.step, deltaX));
      if (pointer.delta > 0 && !pointer.prepared) {
        this.rotate(-1);
        pointer.prepared = true;
        this.syncAccessibility();
      } else if (pointer.delta <= 0 && pointer.prepared) {
        this.rotate(1);
        pointer.prepared = false;
        this.syncAccessibility();
      }
      this.paint(pointer.delta - (pointer.prepared ? this.step : 0));
    }

    pointerEnd(event, cancelled = false) {
      const pointer = this.pointer;
      if (!pointer || pointer.id !== event.pointerId) return;
      this.releasePointer();
      if (!pointer.moving) return;
      this.blockedUntil = Date.now() + 500;
      const commit = !cancelled && Math.abs(pointer.delta) > Math.max(24, this.step * 0.15);
      const direction = pointer.delta < 0 ? 1 : -1;
      const target = pointer.prepared ? (commit ? 0 : -this.step) : (commit ? -this.step : 0);
      this.animate(target, () => {
        if ((pointer.prepared && !commit) || (!pointer.prepared && commit)) this.rotate(1);
        if (commit) this.index = (this.index + direction + this.slides.length) % this.slides.length;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantallas-card-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let observer;
    let scheduled = false;
    let details = new Map();

    const updateCards = () => {
      const grid = document.getElementById('ProductGridContainer');
      if (!grid || details.size === 0) return;

      grid.querySelectorAll('.product-card__title a[href]').forEach((link) => {
        const match = new URL(link.href, window.location.href).pathname.match(/\/products\/([^/]+)/);
        if (!match) return;

        const data = details.get(match[1]);
        if (!data) return;

        const heading = link.closest('.product-card__title');
        if (!heading) return;

        if (data.size) {
          let size = link.querySelector('.pantallas-card-size');
          if (!size) {
            size = document.createElement('span');
            size.className = 'pantallas-card-size';
            link.appendChild(size);
          }
          if (size.textContent !== data.size) size.textContent = data.size;
        }

        if (data.material) {
          let material = heading.nextElementSibling;
          if (!material || !material.classList.contains('pantallas-card-material')) {
            material = document.createElement('p');
            material.className = 'pantallas-card-material';
            heading.insertAdjacentElement('afterend', material);
          }
          if (material.textContent !== data.material) material.textContent = data.material;
        }
      });
    };

    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        updateCards();
      });
    };

    const initialize = () => {
      observer?.disconnect();
      const source = document.querySelector('template[data-pantallas-card-data]');
      const grid = document.getElementById('ProductGridContainer');
      if (!source || !grid) return;

      details = new Map(
        Array.from(source.content.querySelectorAll('[data-handle]'), (item) => [
          item.dataset.handle,
          { size: item.dataset.size?.trim(), material: item.dataset.material?.trim() },
        ])
      );

      observer = new MutationObserver(scheduleUpdate);
      observer.observe(grid, { childList: true, subtree: true });
      scheduleUpdate();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-splide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__splideMediaSection) return;

  const instances = new Map();
  let libraryPromise;

  const loadSplide = (root) => {
    if (window.Splide) return Promise.resolve();
    if (!libraryPromise) {
      libraryPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = root.dataset.splideScript;
        script.async = true;
        script.onload = () => window.Splide ? resolve() : reject(new Error('No se pudo iniciar Splide'));
        script.onerror = () => reject(new Error('No se pudo cargar Splide'));
        document.head.appendChild(script);
      }).catch((error) => {
        libraryPromise = undefined;
        throw error;
      });
    }
    return libraryPromise;
  };

  const initialize = (root) => {
    if (!root) return;
    const id = root.dataset.sectionId;
    instances.get(id)?.destroy();

    const slides = Array.from(root.querySelectorAll('[data-media-slide]'));
    const mobileViewport = window.matchMedia('(max-width: 767px)');
    let splide;
    let activeIndex = 0;
    let destroyed = false;
    let track;
    let touchStart;
    let suppressClickUntil = 0;
    let swipeTimer;

    const onTouchStart = (event) => {
      if (!splide || event.touches.length !== 1) return;
      suppressClickUntil = 0;
      const touch = event.touches[0];
      touchStart = { x: touch.clientX, y: touch.clientY, index: splide.index };
    };

    const onTouchMove = (event) => {
      if (!touchStart || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const x = Math.abs(touch.clientX - touchStart.x);
      const y = Math.abs(touch.clientY - touchStart.y);
      if (x > 8 && x > y * 1.2 && event.cancelable) event.preventDefault();
    };

    const onTouchEnd = (event) => {
      if (!touchStart || !splide || !event.changedTouches.length) return;
      const touch = event.changedTouches[0];
      const x = touch.clientX - touchStart.x;
      const y = touch.clientY - touchStart.y;
      const startIndex = touchStart.index;
      touchStart = null;
      if (Math.abs(x) < 24 || Math.abs(x) <= Math.abs(y) * 1.2) return;

      suppressClickUntil = Date.now() + 400;
      window.clearTimeout(swipeTimer);
      swipeTimer = window.setTimeout(() => {
        if (!destroyed && splide && splide.index === startIndex) {
          splide.go(x < 0 ? '>' : '<');
        }
      }, 0);
    };

    const onTouchCancel = () => { touchStart = null; };

    const onClick = (event) => {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };

    const syncVideos = () => {
      if (destroyed) return;
      const visibleSlide = splide
        ? root.querySelector('[data-media-slide].is-visible')
        : slides[activeIndex];
      root.querySelectorAll('[data-media-slide]').forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          const isMobileVideo = !!video.closest('.splide-media__media--mobile');
          if (slide !== visibleSlide || isMobileVideo !== mobileViewport.matches) {
            video.pause();
            return;
          }
          video.muted = true;
          video.playsInline = true;
          if (video.paused) {
            const request = video.play();
            if (request) request.catch(() => {});
          }
        });
      });
    };

    const destroy = () => {
      destroyed = true;
      window.clearTimeout(swipeTimer);
      track?.removeEventListener('touchstart', onTouchStart, true);
      track?.removeEventListener('touchmove', onTouchMove, true);
      track?.removeEventListener('touchend', onTouchEnd, true);
      track?.removeEventListener('touchcancel', onTouchCancel, true);
      track?.removeEventListener('click', onClick, true);
      mobileViewport.removeEventListener('change', syncVideos);
      root.querySelectorAll('[data-media-slide]').forEach((slide) => slide.querySelectorAll('video').forEach((video) => video.pause()));
      splide?.destroy(true);
      instances.delete(id);
    };

    const instance = {
      destroy,
      select(index) {
        activeIndex = index;
        if (splide) splide.go(index);
        else syncVideos();
      }
    };
    instances.set(id, instance);
    mobileViewport.addEventListener('change', syncVideos);
    slides.forEach((slide) => slide.querySelectorAll('video').forEach((video) => { video.autoplay = false; }));
    syncVideos();

    if (slides.length < 2) return;
    loadSplide(root).then(() => {
      if (destroyed || !root.isConnected) return;
      splide = new window.Splide(root, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        drag: true,
        dragMinThreshold: { mouse: 3, touch: 5 },
        arrows: true,
        pagination: true,
        autoplay: root.dataset.autoplay === 'true',
        interval: Number(root.dataset.interval) || 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        speed: 500
      });
      splide.on('move', (index) => {
        activeIndex = index;
      });
      splide.on('moved', () => {
        activeIndex = splide.index;
        window.requestAnimationFrame(syncVideos);
      });
      splide.mount();
      track = root.querySelector('.splide__track');
      track.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
      track.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
      track.addEventListener('touchend', onTouchEnd, { capture: true, passive: true });
      track.addEventListener('touchcancel', onTouchCancel, { capture: true, passive: true });
      track.addEventListener('click', onClick, true);
      if (activeIndex > 0) splide.go(activeIndex);
      syncVideos();
    }).catch((error) => console.error('[Splide multimedia]', error));
  };

  const rootsIn = (element) => {
    const roots = Array.from(element.querySelectorAll('[data-splide-media]'));
    if (element.matches?.('[data-splide-media]')) roots.unshift(element);
    return roots;
  };

  document.addEventListener('shopify:section:load', (event) => {
    rootsIn(event.target).forEach(initialize);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    rootsIn(event.target).forEach((root) => instances.get(root.dataset.sectionId)?.destroy());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-media-slide]');
    const root = slide?.closest('[data-splide-media]');
    if (!root) return;
    instances.get(root.dataset.sectionId)?.select(Number(slide.dataset.mediaIndex));
  });

  window.__splideMediaSection = { initialize };
  const initializeAll = () => document.querySelectorAll('[data-splide-media]').forEach(initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
